import { useEffect } from 'react';

import { useCampaignPopup } from 'features/add-campaign/form/useCampaignPopup';
import { ROUTE_CAMPAIGNS } from 'navigation/config/routesConfig';

import { Campaigns } from './Campaigns';

export const NewCampaign = () => {
  const { showAddCampaignPopup } = useCampaignPopup();

  useEffect(() => {
    window.history.replaceState(null, '', ROUTE_CAMPAIGNS);
    const clock = setTimeout(showAddCampaignPopup, 750);
    return () => clearTimeout(clock);
  }, []);

  return <Campaigns />;
};
